export const GET_PAGES = "GET_PAGES";
export const FILTER_PAGES = "FILTER_PAGES";
export const ADD_PAGE = "ADD_PAGE";
export const EDIT_PAGE = "EDIT_PAGE";
export const GET_PAGE = "GET_PAGE";
export const RESET_PAGE = "RESET_PAGE";
export const PAGES_ERROR = "PAGES_ERROR";
